export enum CoverFormat {
  CaptionAbove = 'captionAbove',
  CaptionUnder = 'captionUnder',
  FullscreenCaptionOver = 'fullscreenCaptionOver',
  FullscreenCaptionRight = 'fullscreenCaptionRight',
  FullscreenCaptionUnder = 'fullscreenCaptionUnder',
}
